export const getSupportedTypeList = (fileName: string) => {
    const defaultTypes =
        "image/jpeg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-zip-compressed";

    const supportedTypes: any = {
        pdf: "application/pdf",
        zip: "application/zip, application/x-zip-compressed",
        doc: "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        docx: "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        png: "image/jpeg, image/png",
        jpeg: "image/jpeg, image/png",
        jpg: "image/jpeg, image/png"
    };

    const fileType: string = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();

    const supportedFiles = supportedTypes[fileType];
    return supportedFiles !== undefined ? supportedFiles : defaultTypes;
};
